import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'A mi nene de 2 años le encantan las actividades. Se entretiene un montón y noto cómo va aprendiendo palabras nuevas todos los días. ¡Súper recomendado para mamás sin tiempo!',
    name: 'Carolina M.',
    city: 'Córdoba',
    initial: 'C',
    color: 'bg-pink-100 text-pink-700'
  }, {
    quote: 'Me salvó las tardes. Antes perdía horas buscando en Pinterest cosas acordes a su edad. Acá está todo organizado, listo para imprimir y usar. La guía para padres es un 10.',
    name: 'Julieta R.',
    city: 'CABA',
    initial: 'J',
    color: 'bg-blue-100 text-blue-700'
  }, {
    quote: 'La calidad del material es hermosa. Los colores, los dibujos, todo está pensado para llamar su atención. Compré el pack con el upsell y las tarjetas de estimulación son geniales.',
    name: 'Mariana S.',
    city: 'Rosario',
    initial: 'M',
    color: 'bg-purple-100 text-purple-700'
  }, {
    quote: 'Noté un avance enorme en su motricidad fina desde que empezamos con el libro de texturas y clasificación. Es una inversión mínima para todo lo que aporta a su desarrollo.',
    name: 'Agustina P.',
    city: 'Mendoza',
    initial: 'A',
    color: 'bg-green-100 text-green-700'
  }, {
    quote: 'Lo uso con mi bebé de 1 año y con el más grande de 3. Las actividades se adaptan re bien. Es un momento hermoso que compartimos lejos de las pantallas.',
    name: 'Sofía L.',
    city: 'La Plata',
    initial: 'S',
    color: 'bg-yellow-100 text-yellow-700'
  }];
  return <section className="py-10 md:py-14 px-4 bg-[#eef6ff]" data-id="element-297">
      <div className="max-w-6xl mx-auto" data-id="element-298">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-center text-gray-900 mb-8" data-id="element-299">
          Mamás que ya lo comprobaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-300">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 flex flex-col" data-id="element-301">
              <div className="flex gap-1 mb-3" data-id="element-302">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-303" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-1 text-base leading-relaxed" data-id="element-304">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-305">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-306">
                  {t.initial}
                </div>
                <div data-id="element-307">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-308">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-309">{t.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}